// extracted by mini-css-extract-plugin
export default {"counter":"dashboardCount_counter__Aslmj","title":"dashboardCount_title__+l+H4","icon":"dashboardCount_icon__aKTmJ","rotate":"dashboardCount_rotate__z+tY5"};